import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAllUsersNew } from "../../../../redux/features/generalSlice";
import { useSelector } from "react-redux";
import UserSearchAndDiplaySection from "./UserSearchAndDiplaySection";
import { Box, Button } from "@mui/material";
import GoalUserSpecific from "./goal/GoalUserSpecific";
import SkillsUserSpecific from "../../../L&D/Appraisal/adminOperations/userSpecificOperations/skills/SkillsUserSpecific";
import KraLanding from "./Kra/KraLanding";
import WillUserSpecific from "../../../L&D/Appraisal/adminOperations/userSpecificOperations/will/WillUserSpecific";
import useResponsive from "../../../../Hooks/useResponsive";

const UserSpecificLanding = () => {
  const mdUp = useResponsive("up", "md");
  const childFontSize = mdUp ? "0.6rem" : "0.5rem";
  const [selectedUser, setSelectedUser] = useState(() => {
    try {
      const stored = localStorage.getItem("selectedUser");
      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      console.error("Error parsing selectedUser from localStorage", e);
      return {};
    }
  });
  const [isSubmitted, setIsSubmitted] = useState(
    localStorage.getItem("selectedUser") ? true : false
  );
  const [currentyUsedTabId, setCurrentyUsedTabId] = useState(1);
  const { allUsers, loading } = useSelector((store) => store?.general);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllUsersNew());
  }, []);

  const renderTheComponent = () => {
    if (currentyUsedTabId === 1) return <KraLanding user={selectedUser} />;
    if (currentyUsedTabId === 2)
      return <GoalUserSpecific user={selectedUser} />;
    if (currentyUsedTabId === 3)
      return <SkillsUserSpecific user={selectedUser} />;
    if (currentyUsedTabId === 4)
      return <WillUserSpecific user={selectedUser} />;
    return null;
  };

  return (
    <>
      <Box>
        <UserSearchAndDiplaySection
          userDatas={allUsers || []}
          loading={loading}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          isSubmitted={isSubmitted}
          setIsSubmitted={setIsSubmitted}
        />
      </Box>

      {selectedUser?.userID && (
        <>
          <Box
            mt={1}
            p={mdUp ? 0.6 : 0.3}
            sx={{
              display: "flex",
              gap: 1,
              height: "32px",
            }}
          >
            <Button
              disableElevation
              variant={currentyUsedTabId == 1 ? "contained" : "outlined"}
              size="small"
              onClick={() => setCurrentyUsedTabId(1)}
              sx={{
                fontSize: childFontSize,
                boxShadow: "none",
                borderRadius: 2,
                px: mdUp ? 3 : 1,
              }}
              color="secondary"
            >
              KRA
            </Button>
            <Button
              variant={currentyUsedTabId == 2 ? "contained" : "outlined"}
              onClick={() => setCurrentyUsedTabId(2)}
              sx={{
                fontSize: childFontSize,
                boxShadow: "none",
                borderRadius: 2,
                px: mdUp ? 3 : 1,
              }}
              color="secondary"
            >
              GOALS
            </Button>
            <Button
              variant={currentyUsedTabId == 3 ? "contained" : "outlined"}
              onClick={() => setCurrentyUsedTabId(3)}
              sx={{
                fontSize: childFontSize,
                boxShadow: "none",
                borderRadius: 2,
                px: mdUp ? 3 : 1,
              }}
              color="secondary"
            >
              SKILL
            </Button>
            <Button
              variant={currentyUsedTabId == 4 ? "contained" : "outlined"}
              onClick={() => setCurrentyUsedTabId(4)}
              sx={{
                fontSize: childFontSize,
                boxShadow: "none",
                borderRadius: 2,
                px: mdUp ? 3 : 1,
              }}
              color="secondary"
            >
              Will
            </Button>
          </Box>

          <Box>{renderTheComponent()}</Box>
        </>
      )}
    </>
  );
};

export default UserSpecificLanding;
